module.exports = __webpack_public_path__ + "resources/img/img_hyper_personal_m.553d80c0956de300342b2bb241aea4e2.png";